"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeTimetableInput = sanitizeTimetableInput;
var lodash_1 = require("lodash");
function sanitizeTimetableInput(timetable) {
    // Avoid storing null values for "state", "startDate", and "endDate" in UserRole schedules
    return Array.isArray(timetable) && timetable.length
        ? timetable.map(function (r) { return (0, lodash_1.pickBy)(r, function (v) { return v !== null && v !== undefined; }); })
        : undefined;
}
//# sourceMappingURL=sanitizeTimetableInput.js.map